<template>
  <v-container>
    <h3>Rates</h3>
    <v-data-table
      :loading="isLoading"
      :headers="headers"
      :items="tables"
      :items-per-page="5"
      class="elevation-1"
    ></v-data-table>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  props: ["tables"],
  data: () => ({
    headers: [
      {
        text: "Rate Amount",
        value: "rate_Amount"
      },
      {
        text: "Rate Unit",
        value: "rate_Unit"
      }
    ]
  }),
  created() {},
  methods: {
    formatDate: date => moment(date).format("YYYY-MM-DD hh:mm A")
  }
};
</script>
